import { FileSignStatus } from '_constants/default.constants';

export const prepareFileStatus = (
  filePaths: any[],
  fileStatus: FileSignStatus[]
): FileSignStatus[] => {
  return filePaths.map((_, index) => ({
    gv: fileStatus[index]?.gv || false,
    bgh: fileStatus[index]?.bgh || false,
    vanthu: fileStatus[index]?.vanthu || false
  }));
};

export const download = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName.normalize('NFC');

  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
